export const FIELD_CREATION_MODES = {
  order: {
    title: 'Nova ordem de serviço',
    kicker: 'Execução formal e rastreável',
    help: 'Use quando a atividade precisar ser executada, comprovada e depois conferida. O responsável registra a execução, e o proprietário aprova ou devolve para correção.',
    submit: 'Criar ordem de serviço',
    successNoun: 'Ordem de serviço',
    evidenceDefault: true,
  },
  task: {
    title: 'Nova tarefa',
    kicker: 'Atividade simples',
    help: 'Use para algo que precisa ser feito na rotina. O responsável conclui a atividade diretamente, sem depender da aprovação do proprietário.',
    submit: 'Criar tarefa',
    successNoun: 'Tarefa',
    evidenceDefault: false,
  },
};

export function getFieldCreationMode(mode) {
  return FIELD_CREATION_MODES[mode] || FIELD_CREATION_MODES.order;
}
